// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  workspaceId: __t.u64().primaryKey().name("workspace_id"),
  orgId: __t.u64().name("org_id"),
  slug: __t.string(),
  name: __t.string(),
  createdAt: __t.i64().name("created_at"),
  createdBy: __t.identity().name("created_by"),
  daytonaSandboxId: __t.string().name("daytona_sandbox_id"),
  daytonaState: __t.string().name("daytona_state"),
  daytonaLastHeartbeat: __t.i64().name("daytona_last_heartbeat"),
  autonomyLevel: __t.string().name("autonomy_level"),
  digestAtHourLocal: __t.u8().name("digest_at_hour_local"),
  escalationContactEmail: __t.string().name("escalation_contact_email"),
});
